module.exports = __webpack_public_path__ + "custom-config/img/kexinwangzhan@2x.68a19e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/kexinwangzhan@2x.png
// module id = gBM3
// module chunks = 2 3 4 6 7 8 9